
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import {
  getMerchantManagerInfo,
  setMerchantManager,
  addMerchantManager
} from '@/api/merchant/manager'
import { setAdminRules } from '@/utils/rules'
import { delObjEmptyKey } from '@/utils'
import { stringArrayToString, stringToStringArray } from '@/filters'
import { operationMessage } from '@/utils/message'

@Component({
  name: 'editManager',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) merchant_no!: string
  @Prop({ default: '' }) managerId!: string

  private infoForm: any = {
    username: '',
    email: '',
    ip_address: [],
    status: null,
    password: '',
    description: ''
  }
  private capsTooltip = false
  private ip_address: string = '0.0.0.0'
  private loading = false
  private managerInfo: any = {}
  private status: any = '1'
  private rules = setAdminRules

  private checkCapslock(e: KeyboardEvent) {
    const { key } = e
    this.capsTooltip =
      key !== undefined &&
      key !== null &&
      key.length === 1 &&
      key >= 'A' &&
      key <= 'Z'
  }

  private ipAddressChange(e: any) {
    this.infoForm.ip_address = stringToStringArray(e)
  }

  // 编辑IP地址相关操作
  private openIpEdit: boolean = false
  private editIpAddress() {
    this.openIpEdit = true
    // this.infoForm.ip_address.push('')
  }
  private onAdd() {
    this.infoForm.ip_address.push('')
  }
  private onDel(i) {
    this.infoForm.ip_address.splice(i, 1)
  }
  private editIp() {
    this.infoForm.ip_address = this.infoForm.ip_address.filter(item => {
      return item !== ''
    })
    this.openIpEdit = false
  }
  @Watch('infoForm.ip_address')
  private watchIp(i) {
    this.ip_address = stringArrayToString(i)
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close')
  }
  private save() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          this.flag = true
          const data: any = {
            ...this.infoForm,
            merchant_no: this.merchant_no,
            id: this.managerId,
            status: this.status
          }

          delObjEmptyKey(data)
          if (!this.managerId) {
            await addMerchantManager(data).then((res: any) => {
              operationMessage(true)
              this.loading = false
              this.flagStr()
              this.back()
            })
          } else {
            await setMerchantManager(data).then((res: any) => {
              operationMessage(true)
              this.loading = false
              this.flagStr()
              this.back()
            })
          }
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }

  // 获取商户管理员信息
  private async getMerchantManagerInfo() {
    try {
      const data: any = {
        merchant_no: this.merchant_no,
        id: this.managerId
      }
      await getMerchantManagerInfo(data).then((res: any) => {
        this.managerInfo = res
        this.infoForm = Object.assign(this.infoForm, res)
        this.ip_address = stringArrayToString(this.infoForm.ip_address)
        delete this.infoForm.permissions
        delete this.infoForm.manager_type
      })
    } catch (e) {}
  }

  mounted() {
    if (this.infoForm.ip_address.length === 0) {
      this.infoForm.ip_address.push('0.0.0.0')
    }
    if (this.managerId) {
      this.getMerchantManagerInfo()
    }
  }
}
